import React, {Component, Fragment} from 'react';
import {FormGroup, Label} from 'reactstrap';
import Select from 'react-select';

import './RatingMultiResponse.scss';
import './RatingResponse.scss';
import Checkbox from '../../../../shared/forms/Checkbox';
import AutoTextarea from "../../forms/AutoTextarea";

class EvaluationRatingResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCommentOpened: false
    }
  }

  textareaRef = React.createRef();

  componentDidMount() {
    if (this.props.value.notObserved) {
      this.handleCheckInput('notObserved', true);
    }
    if (this.props.value.notResponsive) {
      this.handleCheckInput('notResponsive', true);
    }
    if (this.props.value.rating) {
      this.handleRatingInput(this.props.value.rating);
    }
    this.setState({isCommentOpened: !!this.props.value.comment});
  }

  componentDidUpdate(prevProps) {
    if (!this.state.isCommentOpened && !!this.props.value.comment) {
      this.setState({isCommentOpened: true});
    }
  }

  get ratings() {
    return Array.from(Array(parseInt(this.props.scale || 3, 10)).keys());
  }

  get isCommentRequired() {
    return (this.props.requiredComments || []).find(rc => rc === this.props.value.rating) || (this.isNotResponsiveEnabled && this.props.value.notResponsive)
  }

  get isNotObservedEnabled() {
    return this.props.useNotObserved !== undefined ? this.props.useNotObserved !== false : this.props.useNoNr !== false
  }

  get isNotResponsiveEnabled() {
    return this.props.useNotResponsive !== undefined ? this.props.useNotResponsive !== false : this.props.useNoNr !== false
  }

  get isCommentOpenedComputed() {
    return this.isCommentRequired || this.state.isCommentOpened;
  }

  get ratingOptions() {
    return this.ratings.map(r => ({
      value: r + 1,
      label: this.getScoreLabel(r + 1)
    }))
  }

  getScoreLabel(score) {
    return (this.props.scoreOverrides || {})[score] || score.toString();
  }

  getDefaultComment(rating) {
    return this.props.defaultComments
      && this.props.defaultComments.find(df => df.rating == rating)
      && this.props.defaultComments.find(df => df.rating == rating).comment
  }

  splitDefaultCommentByNewLine(comment) {
    return comment.split(/\r?\n/).map((c, i) => {
      if (i === 0) {
        return <p key={c + i} onClick={() => this.addCommentFromDefaultComment(c)}><b>{c}</b></p>
      }
      return <p key={c + i} onClick={() => this.addCommentFromDefaultComment(c)}>{c}</p>
    })
  }

  addCommentFromDefaultComment(comment) {
    let commentToBeAdded = `${this.props.value.comment}${!!this.props.value.comment ? ' <br/>' : ''}${comment}`;
    this.handleCommentInput(commentToBeAdded);
    if (this.textareaRef.current) {
      this.textareaRef.current.setState({html: commentToBeAdded})
    }
    this.openComment();
  }

  isCommentRequiredForRating(value) {
    return (this.props.requiredComments || []).find(rc => rc === value)
  }

  handleRatingInput(value) {
    const {comment} = this.props.value;
    const valueObject = {
      rating: value,
      notObserved: false,
      notResponsive: false,
      comment
    };
    valueObject.isValid = this.isNextValueValid(valueObject);
    this.props.onValueChange(this.props.name, valueObject);
  }

  handleCommentInput(value) {
    const {notObserved, notResponsive, rating} = this.props.value;
    const valueObject = {
      rating,
      comment: value,
      notObserved,
      notResponsive
    };
    valueObject.isValid = this.isNextValueValid(valueObject);
    this.props.onValueChange(this.props.name, valueObject);
  }

  handleCheckInput(type, value) {
    const {comment} = this.props.value;
    const otherType = (type === 'notObserved') ? 'notResponsive' : 'notObserved';
    const valueObject = {
      comment,
      rating: 0,
      [otherType]: false,
      [type]: value
    };
    valueObject.isValid = this.isNextValueValid(valueObject);
    this.props.onValueChange(this.props.name, valueObject);
  }

  isNextValueValid(value) {
    return (this.isCommentRequiredForRating(value.rating) ? !!value.comment : true) &&
      (this.isNotResponsiveEnabled && value.notResponsive ? !!value.comment : true) &&
      (value.rating || (this.isNotResponsiveEnabled && value.notResponsive) || (this.isNotObservedEnabled && value.notObserved))
  }

  openComment() {
    this.setState({isCommentOpened: true});
  }

  render() {
    return (
      <div className="rating-response rating-multi-response evaluation-rating-response">
        {this.props.showPrompt !== false && <Label style={{whiteSpace: 'pre-wrap'}}>{this.props.ratingPrompt}</Label>}
        {/*{this.props.heading && <div className="evaluation-rating-heading">{this.props.heading}</div>}*/}
        <div className="rating-multi-fields-container">
          <div className="rating-multi-field" style={{marginBottom: '10px', flexWrap: 'wrap'}}>
            <div className="rating-field-set evaluation-rating-select" style={{minWidth: '180px', display: 'block'}}>
              <Select
                value={this.props.value.rating ? {value: this.props.value.rating, label: this.getScoreLabel(this.props.value.rating)} : null}
                isClearable={false}
                isSearchable={false}
                defaultValue={null}
                options={this.ratingOptions}
                name={'value'}
                onChange={(e) => e && this.handleRatingInput(e.value)}
              />
              {this.props.value.rating && this.getDefaultComment(this.props.value.rating) ? (
                <div className="rating-popup">{this.splitDefaultCommentByNewLine(this.getDefaultComment(this.props.value.rating))}</div>
              ) : null}
            </div>

            {(this.isNotObservedEnabled || this.isNotResponsiveEnabled) && (
              <Fragment>
                <div className="rating-check-container">
                  {this.isNotObservedEnabled && (
                    <div className="rating-check">
                      <Checkbox
                        label={this.props.notObservedPrompt}
                        checked={this.props.value.notObserved}
                        onChange={(event) => this.handleCheckInput('notObserved', event.target.checked)}
                      />
                    </div>
                  )}
                  {this.isNotResponsiveEnabled && (
                    <div className="rating-check">
                      <Checkbox
                        label={this.props.notResponsivePrompt}
                        checked={this.props.value.notResponsive}
                        onChange={(event) => this.handleCheckInput('notResponsive', event.target.checked)}
                      />
                    </div>
                  )}
                </div>
              </Fragment>
            )}

            {(this.props.value.notObserved || this.props.value.notResponsive || this.props.value.rating !== undefined)
              && !this.isCommentOpenedComputed && (
                <div style={{marginTop: '5px'}}>
                  <button className="button primary small" type="button" onClick={() => this.openComment()}>
                    <i className="fa fa-plus"></i>
                    <span>Add comment</span>
                  </button>
                </div>
              )}
          </div>
          {this.isCommentOpenedComputed && (
            <div>
              {this.isCommentRequired && <div className="text-danger small">Comment is required</div>}
              <FormGroup>
                <AutoTextarea
                  ref={this.textareaRef}
                  className={(this.props.value.touched && !this.props.value.isValid) ? 'is-invalid' : ''}
                  value={this.props.value.comment}
                  placeholder={this.props.commentPlaceholder || 'Comment'}
                  onChange={(value) => this.handleCommentInput(value)}
                />
              </FormGroup>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EvaluationRatingResponse;
